const DIAS_LABEL = {
	seg: "Seg",
	ter: "Ter",
	qua: "Qua",
	qui: "Qui",
	sex: "Sex",
	sab: "Sáb",
	dom: "Dom",
}

/** Ocupação de um dia civil na janela de candidatura. */
export function GestaoVagaOcupacaoDia({ dia }) {
	if (!dia) return null

	const limite = Math.max(1, Number(dia.limiteTitulares) || 1)
	const ativos = Math.min(limite, Math.max(0, Number(dia.titularesNoDia) || 0))
	const pct = Math.round((ativos / limite) * 100)
	const restantes = Math.max(0, Number(dia.vagasRestantes) ?? limite - ativos)

	let fillClass = "gv-ocupacao__fill--ok"
	if (dia.status === "dia_cheio" || restantes === 0) {
		fillClass = "gv-ocupacao__fill--full"
	} else if (restantes === 1) {
		fillClass = "gv-ocupacao__fill--warn"
	}

	return (
		<div className="gv-ocupacao gv-ocupacao--dia" aria-label={`Ocupação no dia: ${ativos} de ${limite}`}>
			<div className="gv-ocupacao__top">
				<span className="gv-ocupacao__label">Inscritos neste dia</span>
				<span className="gv-ocupacao__contagem">
					{ativos} / {limite}
				</span>
			</div>
			<div className="gv-ocupacao__bar">
				<div
					className={`gv-ocupacao__fill ${fillClass}`}
					style={{ width: `${pct}%` }}
				/>
			</div>
			{restantes > 0 && !dia.jaInscrito ? (
				<span className="gv-ocupacao__restantes">
					{restantes === 1
						? "Resta 1 vaga neste dia"
						: `Restam ${restantes} vagas neste dia`}
				</span>
			) : null}
		</div>
	)
}

export default function GestaoVagaOcupacao({ ingresso }) {
	if (!ingresso) return null

	const limite = Math.max(1, Number(ingresso.limiteTitulares) || 1)
	const ativos = Math.min(limite, Math.max(0, Number(ingresso.titularesAtivos) || 0))
	const pct = Math.round((ativos / limite) * 100)
	const restantes = Math.max(0, limite - ativos)

	let fillClass = "gv-ocupacao__fill--ok"
	if (ingresso.status === "vaga_cheia" || restantes === 0) {
		fillClass = "gv-ocupacao__fill--full"
	} else if (restantes === 1) {
		fillClass = "gv-ocupacao__fill--warn"
	}

	return (
		<div className="gv-ocupacao" aria-label={`Ocupação: ${ativos} de ${limite} titulares`}>
			<div className="gv-ocupacao__top">
				<span className="gv-ocupacao__label">Titulares na vaga</span>
				<span className="gv-ocupacao__contagem">
					{ativos} / {limite}
				</span>
			</div>
			<div className="gv-ocupacao__bar">
				<div
					className={`gv-ocupacao__fill ${fillClass}`}
					style={{ width: `${pct}%` }}
				/>
			</div>
			{restantes > 0 && ingresso.status !== "ja_titular" ? (
				<span className="gv-ocupacao__restantes">
					{restantes === 1
						? "Resta 1 vaga disponível para titular"
						: `Restam ${restantes} vagas disponíveis para titular`}
				</span>
			) : null}
			{ingresso.status === "vaga_cheia" ? (
				<span className="text-sm text-slate-500 mt-1 block">
					Não há vagas de titular disponíveis no momento.
				</span>
			) : null}
		</div>
	)
}

export function GestaoVagaChipIngresso({ ingresso }) {
	if (!ingresso) return null

	const diasComVaga =
		ingresso.diasComVagaDisponivel ?? ingresso.vagasRestantes ?? 0
	const inscritos = ingresso.totalDiasInscritos ?? 0
	const { status } = ingresso

	if (inscritos > 0 || ingresso.jaTitular) {
		const n = inscritos || ingresso.diasTitular?.length || 0
		return (
			<span className="gv-chip gv-chip--ok">
				{n <= 1
					? "Titular em 1 dia na janela"
					: `Titular em ${n} dias na janela`}
			</span>
		)
	}
	if (status === "sem_dias") {
		return <span className="gv-chip gv-chip--muted">Sem dias na janela</span>
	}
	if (status === "vaga_cheia" || diasComVaga === 0) {
		return <span className="gv-chip gv-chip--muted">Janela sem vagas</span>
	}
	if (diasComVaga === 1) {
		return <span className="gv-chip gv-chip--warn">1 dia com vaga</span>
	}
	return (
		<span className="gv-chip gv-chip--brand">
			{diasComVaga} dias com vaga
		</span>
	)
}

export function GestaoVagaDiasTitular({ dias = [] }) {
	if (!dias?.length) return null
	return (
		<div className="gv-dias-titular">
			{dias.map((d) => (
				<span key={d} className="gv-dia-pill">
					{DIAS_LABEL[d] || d}
				</span>
			))}
		</div>
	)
}
